/**
 * Created by JIA on 2020/7/18.
 *      A component show as a text, when you click it will pop a bottom sheet with a input to let you input
 *      you can set the input row
 *      THIS COMPONENT SHOULD USE IN BottomInputRoot
 */

import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import RBSheet from "./RBSheet";
import { Keyboard, Platform, TextInput, View } from "react-native";
import MDIcon from "react-native-vector-icons/MaterialIcons";
import FA5Icon from "react-native-vector-icons/FontAwesome5";

import { convertToPinyin } from "../../utils/Helper";
import UIDs from "../../UIDs";
import SimpleSentence from "./SimpleSentence";

const uid = UIDs.components.ui.bottomPopInput;
const isIos = Platform.OS === "ios";
const defaultRowCount = 1;

const isNumeric = n => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

class BottomPopInputInstance extends Component {
    static BottomPopInputInstanceE;

    static show({ ...config }) {
        if (this.BottomPopInputInstanceE) {
            this.BottomPopInputInstanceE.showRB(config);
        }
    }
    static hide() {
        if (this.BottomPopInputInstanceE) {
            this.BottomPopInputInstanceE.closeRB();
        }
    }

    RBSheet = null;
    inputRef = null;
    inputOpened = false;
    keyboardOpened = false;
    keyboardDidShowListener = false;
    keyboardDidHideListener = false;
    callBackHelper = {
        openCallback: null,
        closeCallback: null,
        submitCallback: null,
        inputProps: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            value: "",
            initialRowCount: 1,
            inputStyle: null,
            inputProps: null,
            inputPlaceHolder: null,
            inputPinyinMode: false,
            inputPlaceHolderTextColor: "#a5a5a5",
            inputValue: "",
            inputOpen: false,
            showRadical: false,
            height: 0,
        };
    }

    _setupInputRef = (ref) => {
        this.inputRef = ref;
        if (this.state.inputOpen && this.inputRef) {
            setTimeout(() => {
                if (this._mounted && this.state.inputOpen && this.inputRef) {
                    this.inputRef.focus();
                }
            }, 200);
        }
    }

    _keyboardDidShow = () => {
        console.log("Keyboard Shown");
        this.keyboardOpened = true;
    };

    _keyboardDidHide = () => {
        console.log("Keyboard Hidden");
        this.keyboardOpened = false;
    };

    componentDidMount() {
        this._mounted = true;
        this.keyboardDidShowListener = Keyboard.addListener("keyboardDidShow", this._keyboardDidShow);
        this.keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", this._keyboardDidHide);
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (this.state.inputOpen && !this.keyboardOpened && this.inputRef) {
    //         //setTimeout(() => {
    //             //if (this.inputRef && !this.keyboardOpened) {
    //                 if (this.inputRef.isFocused()) {
    //                     this.inputRef.blur();
    //                     setTimeout(() => {
    //                         this.inputRef.focus();
    //                     }, 100);
    //                 } else {
    //                     this.inputRef.focus();
    //                 }
    //             //}
    //         //}, 220);
    //     }
    // }

    componentWillUnmount() {
        this._mounted = false;
        this.keyboardDidShowListener.remove();
        this.keyboardDidHideListener.remove();
    }

    renderRadical(height) {
        // return (<PYRadicalView style={{height: height,
        //                                borderTopWidth: StyleSheet.hairlineWidth,
        //                                borderTopColor: '#999'}}/>);
    }

    render() {
        const { initialRowCount, inputStyle, inputPlaceHolder, inputProps, value, inputPlaceHolderTextColor } = this.state;
        const fInitRow = isNumeric(initialRowCount) && _.toNumber(initialRowCount) > 0 ? _.toNumber(initialRowCount) : defaultRowCount;

        const inputMinHeight = Math.max(25 * fInitRow, 36);
        const singleLineInputExtraStyle = isIos ? { height: inputMinHeight, paddingTop: 10 } : {};
        const multiline = fInitRow > 1 || this.state.height >= inputMinHeight;
        const containerMinHeight = 20 + inputMinHeight;
        const candidatesBarHeight =  0;
        const radicalViewHeight =  0;
        return (
            <View>
                <RBSheet
                    ref={ref => {
                        this.RBSheet = ref;
                    }}
                    //height={Math.max(containerMinHeight, this.state.height+20)}
                    animationType="none"
                    openDuration={100}
                    onClose={this._onRBClose}
                    onOpen={this._onRBOpen}
                    customStyles={{
                        //wrapper: { backgroundColor: "transparent" },
                        //mask: { backgroundColor: "transparent" },
                        container: { elevation: 100, height: Math.max(containerMinHeight, this.state.height + 20) + candidatesBarHeight + radicalViewHeight },
                    }}>
                    <View style={{flexDirection: 'column'}}>
                    <View style={styles.inputContainer}>
                        <TextInput
                            customIMECandidates={true} // 自定义自带输入法候选栏
                            style={[styles.input, inputStyle, multiline ? { height: Math.max(inputMinHeight, this.state.height) } : singleLineInputExtraStyle]}
                            //autoFocus={isIos ? false : true}
                            placeholder={inputPlaceHolder}
                            autoCapitalize="none"
                            autoCorrect={false}
                            allowFontScaling={true}
                            editable={true}
                            placeholderTextColor={inputPlaceHolderTextColor}
                            underlineColorAndroid="rgba(0,0,0,0)"
                            {...inputProps}
                            multiline={true} //always make input auto grow up
                            row={fInitRow}
                            textAlignVertical="top"
                            onChangeText={this.onChangeText}
                            onEndEditing={e => this.onEndEditing(e, false)}
                            onSubmitEditing={e => this.onEndEditing(e, true)}
                            onContentSizeChange={this._onContentSizeChange}
                            value={this.state.inputValue}
                            ref={this._setupInputRef}
                            returnKeyType="go"
                        />
                        <MDIcon name="send" style={[styles.inputIcon, styles.inputIconSend]} onPress={this._closeRB} />
                    </View>
                    {this.state.showRadical ? this.renderRadical(radicalViewHeight) : null}
                    </View>
                </RBSheet>
            </View>
        );
    }

    _onRBClose = () => {
        if (this.state.inputOpen) {
            this.setState({ inputOpen: false, showRadical: false }, () => {
                if (this.inputRef) {
                    this.inputRef.blur();
                }
                if (this.callBackHelper.closeCallback && _.isFunction(this.callBackHelper.closeCallback)) {
                    this.callBackHelper.closeCallback(this.state.inputValue);
                }
            });
        }
    };

    _onRBOpen = () => {
        this.inputOpened = true;
        if (!this.state.inputOpen) {
            this.setState({ inputOpen: true }, () => {
                if (this.callBackHelper.openCallback && _.isFunction(this.callBackHelper.openCallback)) {
                    this.callBackHelper.openCallback();
                }

                if (this.inputRef) {
                    this.inputRef.blur();
                    setTimeout(() => {
                        if (this._mounted && this.inputRef) {
                            this.inputRef.focus();
                        }
                    }, 200);
                }
            });
        }
    };

    _closeRB = () => {
        //first submit change

        if (this.RBSheet) {
            //sync value back, note for this component, we only change real value when you submit rb
            this.setState({ value: this.state.inputValue }, () => {
                if (this.callBackHelper.submitCallback && _.isFunction(this.callBackHelper.submitCallback)) {
                    this.callBackHelper.submitCallback(this.state.inputValue);
                }
                this.RBSheet.close();
            });
        }
    };

    onChangeText = val => {
        this.setState({ inputValue: val }, () => {
            if (this.callBackHelper.inputProps && this.state.inputProps.onChangeText && _.isFunction(this.callBackHelper.inputProps.onChangeText)) {
                this.callBackHelper.inputProps.onChangeText(val);
            }
        });
    };

    /**
     * handle the pinyin mode , we will convert the input like wu3 to wu
     * @param e
     */
    onEndEditing = (e, forSubmit) => {
        if (e && e.nativeEvent) {
            const { text } = e.nativeEvent;
            let convertText = text;
            if (this.state.inputPinyinMode) {
                convertText = convertToPinyin(text);
            }
            const previousValue = this.state.inputValue;
            this.setState({ inputValue: convertText }, () => {
                if (previousValue !== convertText) {
                    if (this.callBackHelper.inputProps && this.callBackHelper.inputProps.onChangeText && _.isFunction(this.callBackHelper.inputProps.onChangeText)) {
                        this.callBackHelper.inputProps.onChangeText(convertText);
                    }
                }
                // if (this.props.onChangeText && _.isFunction(this.props.onChangeText)) {
                //     this.props.onChangeText(convertText);
                // }
                if (forSubmit) {
                    // const fInitRow = isNumeric(this.state.initialRowCount) && _.toNumber(this.state.initialRowCount) > 0 ? _.toNumber(this.state.initialRowCount) : defaultRowCount;
                    //
                    // //for submit we will close sheet
                    // //we only do this when it is single row mode, for multi row it will insert a line break
                    // if (fInitRow === 1) {
                    //     setTimeout(() => {
                    //         this._closeRB();
                    //     }, 200);
                    // }
                    if (this.callBackHelper.inputProps && this.callBackHelper.inputProps.onSubmitEditing && _.isFunction(this.callBackHelper.inputProps.onSubmitEditing)) {
                        this.callBackHelper.inputProps.onSubmitEditing(convertText);
                    }
                } else {
                    if (this.callBackHelper.inputProps && this.callBackHelper.inputProps.onEndEditing && _.isFunction(this.callBackHelper.inputProps.onEndEditing)) {
                        this.callBackHelper.inputProps.onEndEditing(convertText);
                    }
                }
            });
        }
    };

    _onContentSizeChange = event => {
        this.setState({ height: event.nativeEvent.contentSize.height }, () => {
            if (this.state.inputProps && this.state.inputProps.onContentSizeChange && _.isFunction(this.state.inputProps.onContentSizeChange)) {
                this.state.inputProps.onContentSizeChange(event);
            }
        });
    };

    /**
     * show pop
     * @param config
     *          {
                 value: defaultValue,
                 initialRowCount: initialRowCount,
                 inputStyle: inputStyle,
                 inputProps: inputProps,
                 inputPlaceHolder: inputPlaceHolder,
                 closeCallback: closeCallback,
                 submitCallback: submitCallback,
                 onChangeText: onChangeText,
             }
     */
    showRB = config => {
        //console.log(config);
        this.callBackHelper = {
            openCallback: config.openCallback,
            closeCallback: config.closeCallback,
            submitCallback: config.submitCallback,
            inputProps: config.inputProps,
        };
        this.setState(
            {
                value: config.value,
                inputValue: config.value,
                initialRowCount: config.initialRowCount,
                inputStyle: config.inputStyle,
                inputPlaceHolder: config.inputPlaceHolder,
                inputProps: config.inputProps,
                inputPinyinMode: config.inputPinyinMode,
                inputPlaceHolderTextColor: config.inputPlaceHolderTextColor,
            },
            () => {
                if (this.RBSheet) {
                    this.RBSheet.open();
                    // InteractionManager.runAfterInteractions(() => {
                    //     if (this.inputRef && !this.keyboardOpened) {
                    //         if (this.inputRef.isFocused()) {
                    //             this.inputRef.blur();
                    //             setTimeout(() => {
                    //                 this.inputRef.focus();
                    //             }, 100);
                    //         } else {
                    //             this.inputRef.focus();
                    //         }
                    //     }
                    // });
                }
            }
        );
    };

    closeRB = () => {
        this.RBSheet.close();
    };

    getText = () => {
        return this.state.value;
    };
}

class BottomPopInputText extends Component {
    inputOpened = false;

    constructor(props) {
        super(props);
        let nextValue = props.inputPinyinMode ? convertToPinyin(props.defaultValue) : props.defaultValue;
        if (!_.isEmpty(props.value)) {
            nextValue = props.inputPinyinMode ? convertToPinyin(props.value) : props.value;
        }
        this.state = {
            value: nextValue,
            inputOpen: false,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextValue = nextProps.inputPinyinMode ? convertToPinyin(nextProps.defaultValue) : nextProps.defaultValue;
        if (!_.isEqual(this.props.defaultValue, nextValue)) {
            let changeState = { value: nextValue };

            this.setState(changeState);
        }

        // when you set value from props, we just use your value as the value
        if (nextProps.value !== this.props.value && nextProps.value) {
            const val = nextProps.inputPinyinMode ? convertToPinyin(nextProps.value) : nextProps.value;
            this.setState({ value: val });
        }
    }

    render() {
        const { pencilIconStyle, style, showPencilIconInline, placeholder, placeholderTextColor, showPlaceHolder, disabled } = this.props;
        const finalPlaceHolder = placeholder && placeholder.length > 0 ? placeholder : this.props.t("defaultPlaceHolder");
        const { value } = this.state;
        const finalShowPlaceHolder = showPlaceHolder && !(value && value.length > 0);

        return (
            <SimpleSentence  style={[style, finalShowPlaceHolder ? { color: placeholderTextColor } : null]} onPress={!disabled ? this._openRB : null}>
                {finalShowPlaceHolder ? finalPlaceHolder : value} {showPencilIconInline ? <FA5Icon name="pencil-alt" style={[pencilIconStyle]} /> : null}
            </SimpleSentence >
        );
    }
    _openRB = () => {
        const { initialRowCount, inputStyle, inputProps, placeholder, placeholderTextColor, inputPinyinMode, closeCallback, submitCallback, onChangeText, onBlur, onOpen } = this.props;

        const config = {
            value: this.state.value,
            initialRowCount: initialRowCount,
            inputStyle: inputStyle,
            inputProps: inputProps,
            inputPlaceHolder: placeholder,
            inputPlaceHolderTextColor: placeholderTextColor,
            inputPinyinMode: inputPinyinMode,
            openCallback: () => {
                if (onOpen && _.isFunction(onOpen)) {
                    onOpen();
                }
            },
            closeCallback: val => {
                const previousValue = this.state.value;
                this.setState({ inputOpen: false, showRadical: false, value: val }, () => {
                    if (previousValue !== val) {
                        if (onChangeText && _.isFunction(onChangeText)) {
                            onChangeText(val);
                        }
                    }
                    if (closeCallback && _.isFunction(closeCallback)) {
                        closeCallback(val);
                    }
                    if (onBlur && _.isFunction(onBlur)) {
                        onBlur();
                    }
                });
            },
            submitCallback: val => {
                const previousValue = this.state.value;
                this.setState({ inputOpen: false, showRadical: false, value: val }, () => {
                    if (previousValue !== val) {
                        if (onChangeText && _.isFunction(onChangeText)) {
                            onChangeText(val);
                        }
                    }

                    if (submitCallback && _.isFunction(submitCallback)) {
                        submitCallback(val);
                    }
                });
            },
        };
        if (!this.state.inputOpen) {
            this.setState({ inputOpen: true }, () => {
                BottomPopInputInstance.show(config);
            });
        }
    };

    getText = () => {
        return this.state.value;
    };
}

//for native base stuff we just pass plain objects
const styles = {
    inputContainer: {
        borderTopWidth: 1.5,
        borderTopColor: "#ccc",
        flexDirection: "row",
        alignItems: "center",
        padding: 10,
    },
    inputIcon: {
        fontSize: 24,
        color: "#666",
        marginHorizontal: 5,
    },
    inputIconSend: {
        color: "#006BFF",
    },
    input: {
        flex: 1,
        //height: 36,
        borderRadius: 6,
        paddingHorizontal: 10,
        backgroundColor: "#f1f1f1",
        marginHorizontal: 10,
    },
};

BottomPopInputText.propTypes = {
    initialRowCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    inputStyle: PropTypes.object,
    inputProps: PropTypes.object,
    placeholder: PropTypes.string,
    onChangeText: PropTypes.func,
    onBlur: PropTypes.func,
    onOpen: PropTypes.func,
    inputPinyinMode: PropTypes.bool,
    showPlaceHolder: PropTypes.bool,
    showPencilIconInline: PropTypes.bool,
    defaultValue: PropTypes.string,
    trueVal: PropTypes.string,
    pencilIconStyle: PropTypes.object,
    closeCallback: PropTypes.func,
    submitCallback: PropTypes.func,
    placeholderTextColor: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool,
};

BottomPopInputText.defaultProps = {
    initialRowCount: defaultRowCount,
    inputStyle: {},
    inputProps: {},
    onChangeText: () => {},
    onBlur: () => {},
    onOpen: () => {},
    inputPinyinMode: false,
    showPlaceHolder: true,
    showPencilIconInline: true,
    defaultValue: "",
    trueVal: "",
    pencilIconStyle: {},
    closeCallback: null,
    submitCallback: null,
    placeholderTextColor: "#a5a5a5",
    disabled: false
};

export default withTranslation(uid, { withRef: true })(BottomPopInputText);
export { BottomPopInputInstance };
